import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4342e726"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["PageModal"], {
    shouldShow: $setup.shouldShowModal,
    onBackHandler: () => $setup.toggleShowModal(false)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], {
          title: "비밀번호 변경",
          overrideOnClickBack: true,
          shouldHideBackButton: true,
          shouldHideCloseButton: false,
          shouldShowUnderline: false,
          onOnClickClose: $setup.handleClickCloseButton
        }),
        _createCommentVNode(" 임시비밀번호로 로그인한 경우 "),
        _createVNode($setup["ChangePasswordForm"], { isPasswordExpired: false })
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]))
}